// React Basic and Bootstrap
import React, { Component } from 'react';
import {Row, Col, Alert} from 'reactstrap';

// Import images
import shapeLight from "../../images/shapes/shape-light.png";
import KEC from '../../images/KEC-Logo.png'
import innovAlliance from '../../images/innov865-alliance.png'
import ktech from '../../images/ktech_logo.png'
import teknovation from '../../images/teknovation_logo.png'
import UTRP from '../../images/UTRP_Logo.png'
import {API} from "aws-amplify";

class NewsLetter extends Component {

  constructor(props) {
    super(props);
    this.state = {
      Contactvisible : false,
      firstName: '',
      lastName: '',
      email: '',
      subject: '',
      message: ''
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    let apiName = 'startup-knox'; // replace this with your api name.
    let path = 'newsletterSubscribe'; //replace this with the path you have configured on your API
    let myInit = {
      body: {
        email: this.state.email,
        firstName: this.state.firstName,
        lastName: this.state.lastName
      }, // replace this with attributes you need
      headers: {
        // 'Content-Type': 'application/json',
        // 'Accept': 'application/json',
        // 'Access-Control-Allow-Origin': '*',
        // 'Access-Control-Allow-Credentials': true
      } // OPTIONAL
    }

    API.post(apiName, path, myInit).then(response => {
      console.log('post succeeded!', response)
      this.setState({Contactvisible : true, firstName: '', lastName: '', message: '', email: ''});

    }).catch(error => {
      this.setState({Contactvisible : true, firstName: '', lastName: '', message: '', email: ''});
      console.log('post failed!', error)
    });
  }

  render() {
    return (
      <React.Fragment>
        <section className="section" id={"newsletter"}>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 text-center">
                <div className="section-title mb-4 pb-2">
                  <h4 className="display-3 mb-4">The Newsletter Collective</h4>
                  <p className="text-muted para-desc mb-0 mx-auto"> Sign up to receive updates from Startup Knox and a collection of the most active and connected newsletters in East Tennessee covering innovation, technology, and entrepreneurship. Subscribe and stay in tune with Knoxville's ecosystem.</p>
                </div>
              </div>
            </div>
            <Row>
              <Col md={4} className="col-12 mt-5">
                <div className="features text-center">
                  <div style={{height: 60}}>
                    <img src={innovAlliance} style={{height: 60}} />
                  </div>

                  <div className="content mt-4">
                    <h4 className="title-2">Innov865 Alliance</h4>
                    <p className="text-muted mb-0">The Innov865 Alliance develops, supports, and promotes the Knoxville region’s entrepreneurial ecosystem. It is a collaborative effort to celebrate and showcase Knoxville as a great place for entrepreneurs to start and grow businesses and increase access to capital. Innov865 Week is our signature event; however, the Alliance coordinates other activities throughout the year, including pitch competitions, educational opportunities, and social events.</p>
                  </div>
                </div>
              </Col>

              <Col md={4} className="col-12 mt-5">
                <div className="features text-center">
                  <div style={{height: 60}}>
                    <img src={ktech} style={{height: 60}} />
                  </div>

                  <div className="content mt-4">
                    <h4 className="title-2">Knoville Technology Council</h4>
                    <p className="text-muted mb-0">The Knoxville Technology Council (KTech) connects, develops, promotes, and advocates for the technology industry in the Greater Knoxville region. We believe the technology industry is essential for our community to thrive. KTech unites the region’s technology leaders and empowers businesses and entrepreneurs through networks, events, resources, and more.</p>
                  </div>
                </div>
              </Col>

              <Col md={4} className="col-12 mt-5">
                <div className="features text-center">
                  <div style={{height: 60}}>
                    <img src={teknovation} style={{width: 250, marginBottom: -15}} />
                  </div>
                  <div className="content mt-4">
                    <h4 className="title-2">Teknovation</h4>
                    <p className="text-muted mb-0">Teknovation.biz is a vehicle to allow East Tennesseans to share their successes, learn about the successes of others and focus on strategies that will make a long-term difference. It is intended to help create more awareness of our region’s assets and help drive technology, innovation and entrepreneurial job growth. Teknovation.biz is also a place where links to developments in other areas of Tennessee and beyond will be posted.</p>
                  </div>
                </div>
              </Col>
              <Col md={4} className="col-12 mt-5">
                <div className="features text-center">
                  <div style={{height: 60}}>
                    <img src={KEC} style={{height: 60}} />
                  </div>

                  <div className="content mt-4">
                    <h4 className="title-2">Knoxville Entrepreneur Center</h4>
                    <p className="text-muted mb-0">Knoxville Entrepreneur Center is a business accelerator located in Market Square built to serve as the front door for entrepreneurs in East Tennessee.</p>
                  </div>
                </div>
              </Col>
              <Col md={4} className="col-12 mt-5">
                <div className="features text-center">
                  <div style={{height: 60}}>
                    <img src={UTRP} style={{height: 60}} />
                  </div>

                  <div className="content mt-4">
                    <h4 className="title-2">University Tennessee Research Park</h4>
                    <p className="text-muted mb-0">The University of Tennessee Research Park at Cherokee Farm is located just across the Tennessee River from UT’s flagship campus in Knoxville – an ideal location for companies and entrepreneurs to collaborate with the talent at UT.</p>
                  </div>
                </div>
              </Col>
              <Col md={4} className="col-12 mt-5">
              </Col>
            </Row>
          </div>

          <div className="container" style={{marginTop: 15}}>
            <Row className="justify-content-center">
              <Col lg={12}>
                <Alert color="info" isOpen={this.state.Contactvisible} toggle={()=>{ this.setState({Contactvisible : !this.state.Contactvisible}) }}>
                  Thank you for joining our collective!
                </Alert>

                <form onSubmit={this.handleSubmit} className="p-4 shadow bg-white rounded">
                  <h4 className="mb-3">Get All Five Newsletters</h4>
                  <Row className="text-left">
                    <Col lg={3} md={4}>
                      <div className="form-group position-relative">
                        <label>First Name <span className="text-danger">*</span></label>
                        <i className="mdi mdi-account ml-3 icons"></i>
                        <input name="name" id="name" type="text" className="form-control pl-5" placeholder="First Name :" value={this.state.firstName} required onChange={(e) => this.setState({...this.state, firstName: e.target.value})}/>
                      </div>
                    </Col>
                    <Col lg={3} md={4}>
                      <div className="form-group position-relative">
                        <label>Last Name <span className="text-danger">*</span></label>
                        <i className="mdi mdi-account ml-3 icons"></i>
                        <input name="name" id="name" type="text" className="form-control pl-5" placeholder="Last Name :" value={this.state.lastName} required onChange={(e) => this.setState({...this.state, lastName: e.target.value})}/>
                      </div>
                    </Col>
                    <Col lg={3} md={4}>
                      <div className="form-group position-relative">
                        <label>Your Email <span className="text-danger">*</span></label>
                        <i className="mdi mdi-email ml-3 icons"></i>
                        <input name="email" id="email" type="email" className="form-control pl-5" placeholder="Your email :" value={this.state.email} required onChange={(e) => this.setState({...this.state, email: e.target.value})}/>
                      </div>
                    </Col>

                    <Col lg={3} style={{paddingTop: 30}}>
                      <Col sm={12} className="text-center">
                        <input type="submit" id="submit" name="send" className="submitBnt btn btn-primary btn-block" value="Register" />
                        <div id="simple-msg"></div>
                      </Col>
                    </Col>
                  </Row>
                </form>
              </Col>
            </Row>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default NewsLetter;
